import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(({ custom }) => ({
  menuItems: {
    zIndex: 999999,
  },
}));
